import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { TitleBlockInfo } from '../../object3D/TitleBlock/TitleBlockInfo';
import { RailingColorsService } from '../../../railing/services/railing-colors.service';
import { EstimatorsService } from '../../estimators.service';
import { DataForDisplayingMenuItemsService } from '../../../data-for-displaying-menu-items.service';
import { DeckHeightService } from '../../../deck-height.service';
import { CmToFtAndInch } from '../../lengthConvertor';
import { ProjectManagerService } from '../../../project-manager.service';
import { TitleBlockWarningComponent } from '../title-block-warning/title-block-warning.component.';
import { AuthService } from '../../../auth.service';

import { FormControl } from '@angular/forms';
import { forEach } from '@angular/router/src/utils/collection';

@Component({
  selector: 'app-title-block-info',
  templateUrl: 'title-block-info.component.html',
  styleUrls: ['./title-block-info.component.scss']
})
export class TitleBlockInfoComponent {

  @ViewChild('sizeCalculationDiv') sizeCalculationDiv: ElementRef;
  date: any;
  info: any;
  contractors: any;
  currentChoises: any;
  currentColors: (type: any) => any;
  currentColor: any;
  cleared: boolean;
  oldData: any;

  constructor(
    private dialog: MatDialog,
    private estimatorsService: EstimatorsService,
    private dialogRef: MatDialogRef<TitleBlockInfoComponent>,
    private colorsService: RailingColorsService,
    private dataForMenu: DataForDisplayingMenuItemsService,
    private deckHeightService: DeckHeightService,
    private projectManager: ProjectManagerService,
    private auth: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: TitleBlockInfo | null
  ) {
    // console.log('editorElement - ', this.projectManager.getCurrentProject());
    this.date = new FormControl(new Date());
    this.info = { ...data };
    this.cleared = false;
    this.info.Cleared = true;
    this.isCleared();
    if (!this.info.Cleared) {

      this.colorsService.getColors().subscribe(colors => {
        colors.forEach(c => {
          this.colors.push(c.name);
        });
        this.colors.push("custom");
        this.isElCustom[8] = true;
        for (let i = 0; i < this.colors.length - 1; i++) {
          if (this.info.LeftSideItems[7].value === this.colors[i]) {
            this.isElCustom[8] = false;
          }
        }
        if (this.info.LeftSideItems[7].value === "") {
          this.isElCustom[8] = false;
        }
      });
    } else {

      this.currentChoises = this.dataForMenu.getCurrentParams();
      this.currentColors = this.dataForMenu.getRailingCurrentColor(this.currentChoises.railingType);
      this.currentColor = this.currentColors["Stair Handrail"] ?
        this.currentColors["Stair Handrail"].selected.name :
        this.currentColors["Top Rail"].selected.name;
      // this.info.LeftSideItems[7].value = this.getColor(this.currentColor);
      this.colorsService.getColors().subscribe(colors => {
        colors.forEach(c => {
          this.colors.push(c.name);
        });
        this.colors.push("custom");
        this.info.LeftSideItems[7].value = this.getColor(this.currentColor);
      });
      this.info.LeftSideItems[0].value = this.getRailingType(this.currentChoises.railingType);
      this.info.LeftSideItems[1].value = this.getInfill(this.currentChoises.infill);
      this.info.LeftSideItems[2].value = CmToFtAndInch(this.deckHeightService.getDeckHeight());
      this.info.LeftSideItems[3].value = this.getDeckMaterial(this.projectManager.getDeckMaterial());
      this.info.LeftSideItems[4].value = this.getPostMount(this.currentChoises.postMounting);
      this.info.LeftSideItems[5].value = this.getBottomRail(this.currentChoises.infill);
      this.info.LeftSideItems[6].value = this.getTopRail(this.currentChoises.topRail);
      this.info.LeftSideItems[13].value = this.getRHeight(this.currentChoises.railingHeight);

      this.info.LeftSideItems[11].value = this.getIsCommercial(this.projectManager.getProjectType());
      // console.log(this.currentChoises);
    }

    this.estimatorsService.getEstimators()
      .subscribe(contractors => {
        this.contractors = contractors;
        this.contractors.forEach(e => {
          this.estimators.push(e.firstName + " " + e.lastName);
        });
        this.estimators.push("custom");
        this.isElCustom[0] = true;
        for (let i = 0; i < this.estimators.length - 1; i++) {
          if (this.info.TopItems[1].value === this.estimators[i]) {
            this.isElCustom[0] = false;
          }
        }
        if (this.info.TopItems[1].value === "") {
          this.isElCustom[0] = false;
        }
      });


      this.isElCustom[1] = true;
      for (let i = 0; i < this.railingTypes.length - 1; i++) {
        if (this.info.LeftSideItems[0].value === this.railingTypes[i]) {
          this.isElCustom[1] = false;
        }
      }

      this.isElCustom[2] = true;
      for (let i = 0; i < this.infills.length - 1; i++) {
        if (this.info.LeftSideItems[1].value === this.infills[i]) {
          this.isElCustom[2] = false;
        }
      }

      this.isElCustom[3] = true;
      for (let i = 0; i < this.rHeights.length - 1; i++) {
        if (this.info.LeftSideItems[13].value === this.rHeights[i]) {
          this.isElCustom[3] = false;
        }
      }

      this.isElCustom[4] = true;
      for (let i = 0; i < this.deckMaterials.length - 1; i++) {
        if (this.info.LeftSideItems[3].value === this.deckMaterials[i]) {
          this.isElCustom[4] = false;
        }
      }

      this.isElCustom[5] = true;
      for (let i = 0; i < this.mountTypes.length - 1; i++) {
        if (this.info.LeftSideItems[4].value === this.mountTypes[i]) {
          this.isElCustom[5] = false;
        }
      }

      this.isElCustom[6] = true;
      for (let i = 0; i < this.presences.length - 1; i++) {
        if (this.info.LeftSideItems[5].value === this.presences[i]) {
          this.isElCustom[6] = false;
        }
      }

      this.isElCustom[7] = true;
      for (let i = 0; i < this.topRails.length - 1; i++) {
        if (this.info.LeftSideItems[6].value === this.topRails[i]) {
          this.isElCustom[7] = false;
        }
      }




      this.isElCustom[9] = true;
      for (let i = 0; i < this.intOrExt.length - 1; i++) {
        if (this.info.LeftSideItems[9].value === this.intOrExt[i]) {
          this.isElCustom[9] = false;
        }
      }

      this.isElCustom[10] = true;
      for (let i = 0; i < this.presences.length - 1; i++) {
        if (this.info.LeftSideItems[10].value === this.presences[i]) {
          this.isElCustom[10] = false;
        }
      }

      this.isElCustom[11] = true;
      for (let i = 0; i < this.presences.length - 1; i++) {
        if (this.info.LeftSideItems[11].value === this.presences[i]) {
          this.isElCustom[11] = false;
        }
      }

      this.isElCustom[12] = true;
      for (let i = 0; i < this.presences.length - 1; i++) {
        if (this.info.GatesItems[0].value === this.presences[i]) {
          this.isElCustom[12] = false;
        }
      }

      this.isElCustom[13] = true;
      for (let i = 0; i < this.presences.length - 1; i++) {
        if (this.info.CablerailKitItems[0].value === this.presences[i]) {
          this.isElCustom[13] = false;
        }
      }

  }

  getColor(color) {
    var color = null;
    this.colors.forEach(c => {
      if (c === this.currentColor) {
        color = c;
      }
    });
    return color;
  }

  getIsCommercial(type) {
    var prType = null;
    if (type === "home") {
      prType = this.presences[1];
    } else {
      prType = this.presences[0];
    }
    return prType;
  }

  getBottomRail(type) {
    var bottom = null;
    if (type === "horizontalCable") {
      bottom = this.presences[1];
    } else {
      bottom = this.presences[0];
    }
    return bottom;
  }

  getRailingType(rType) {
    var railingType = null;
    switch (rType) {
      case "DesignRail":
        railingType = this.railingTypes[0];
        break;
      case "Wood":
        railingType = this.railingTypes[1];
        break;
      case "Composite":
        railingType = this.railingTypes[2];
        break;
      case "Steel flat bar":
        railingType = this.railingTypes[3];
        break;
      case "Steel round tubular":
        railingType = this.railingTypes[4];
        break;
      default:
        {
          railingType = rType;
          this.isElCustom[0] = true;
        }
    }
    return railingType;
  }

  public isElCustom: boolean[] = [false, false, false, false, false,
    false, false, false, false, false, false, false, false, false];

  isCustom(field, number) {
    if (field == "custom") {
      if (!this.isElCustom[number]) {
        this.isElCustom[number] = true;
      }
    } else {
      this.isElCustom[number] = false;
    }
  }

  railingTypes: string[] = [
    "Design Rail", "Wood", "Composite Wrapped Wood", "Steel Flat Bar", "Steel Round Tubular", "custom"
  ];

  colors: string[] = [];

  estimators: string[] = [];

  getInfill(inf) {
    var infill = null;
    switch (inf) {
      case "verticalPicket":
        infill = this.infills[0];
        break;
      case "verticalCable":
        infill = this.infills[1];
        break;
      case "glass":
        infill = this.infills[2];
        break;
      case "horizontalCableBaserail":
        infill = this.infills[3];
        break;
      case "horizontalCable":
        infill = this.infills[3];
        break;
    }
    return infill;
  }

  infills: string[] = [
    "Vertical Pickets", "Vertical Cable", "Glass", "Horizontal Cable", "custom"
  ];

  getDeckMaterial(DM) {
    var deckMaterial = null;
    switch (DM) {
      case "wood-redWood":
        deckMaterial = this.deckMaterials[0];
        break;
      case "wood-ipe":
        deckMaterial = this.deckMaterials[1];
        break;
      case "wood-gray":
        deckMaterial = this.deckMaterials[2];
        break;
      case "wood-cedar":
        deckMaterial = this.deckMaterials[3];
        break;
      case "tile-sand":
        deckMaterial = this.deckMaterials[4];
        break;
      case "tile-gray":
        deckMaterial = this.deckMaterials[5];
        break;
      case "concrete":
        deckMaterial = this.deckMaterials[6];
        break;
      case "composite-redWood":
        deckMaterial = this.deckMaterials[7];
        break;
      case "composite-ipe":
        deckMaterial = this.deckMaterials[8];
        break;
      case "composite-gray":
        deckMaterial = this.deckMaterials[9];
        break;
      case "composite-cedar":
        deckMaterial = this.deckMaterials[10];
        break;
    }
    return deckMaterial;
  }

  deckMaterials: string[] = [
    "Wood Redwood", "Wood Ipe", "Wood Gray", "Wood Cedar", "Tile Sand", "Tile Gray", "Concrete", "Composite Redwood", "Composite Ipe", "Composite Gray", "Composite Cedar", "custom"
  ];

  getPostMount(mount) {
    var postMounting = null;
    switch (mount) {
      case "Base Mount":
        postMounting = this.mountTypes[0];
        break;
      case "Fascia Bracket Mount":
        postMounting = this.mountTypes[1];
        break;
      case "Fascia Mount":
        postMounting = this.mountTypes[2];
        break;
      case "Stantion Mount":
        postMounting = this.mountTypes[3];
        break;
      case "Core Mount":
        postMounting = this.mountTypes[4];
        break;
    }
    return postMounting;
  }

  mountTypes: string[] = [
    "Surface Base", "Fascia Bracket", "Fascia", "Stanchion", "Inset", "custom"
  ]

  presences: string[] = [
    "Yes", "No", "custom"
  ]

  getTopRail(value) {
    var topRail = null;
    switch (value) {
      case "150s":
        topRail = this.topRails[0];
        break;
      case "100s":
        topRail = this.topRails[1];
        break;
      case "300s":
        topRail = this.topRails[2];
        break;
      case "200s":
        topRail = this.topRails[3];
        break;
      case "350s":
        topRail = this.topRails[4];
        break;
      case 'Low-Profile for Wood':
        topRail = this.topRails[5];
        break;
      case "450sWithoutCap":
        topRail = this.topRails[6];
        break;
      case "150s":
        topRail = this.topRails[7];
        break;
      case "Wood 2x4":
        topRail = this.topRails[8];
        break;
      case "CompositeBetween":
        topRail = this.topRails[9];
        break;
      case "CompositeTop":
        topRail = this.topRails[10];
        break;
      case "Steel Flatbar":
        topRail = this.topRails[11];
        break;
      case "Steel Tubular":
        topRail = this.topRails[12];
        break;
    }
    return topRail;
  }

  topRails: string[] = [
    "graspable, series 150", "square, series 100", "round, series 300", "rectangular, series 200", "elliptical, series 350",
    "low profile, series 450 (with cap)", "low profile, series 450 (no cap)", "aluminum, series 150 (between posts)", "wood (on top of posts)",
    "composite (between posts)", "composite (on top of posts)", "steel flat bar", "steel tubular round", "custom"
  ];

  intOrExt: string[] = [
    "Int", "Ext", "custom"
  ];

  getRHeight(value) {
    var railingHeight = null;
    switch (value) {
      case "36":
        railingHeight = this.rHeights[0];
        break;
        // http://146.185.164.175:8080/browse/FR-1001
      case "39":
        railingHeight = this.rHeights[1];
        break;
      case "42":
        railingHeight = this.rHeights[2];
        break;
    }
    return railingHeight;
  }

  rHeights: string[] = [
    // http://146.185.164.175:8080/browse/FR-1001
    '36"', '39"', '42"', "custom"
  ];


  isCleared() {
    this.info.TopItems.forEach(item => {
      if (item.value !== "" && item.name !== "DATE") {
        this.info.Cleared = false;
      }
    });

    this.info.Items.forEach(is => {
      is.forEach(i => {
        if (i.value !== "") {
          this.info.Cleared = false;
        }
      })
    });
  }


  async apply() {
    this.isCleared();

    if (this.info.Cleared) {
      const dialogRef = this.dialog.open(TitleBlockWarningComponent, {
        width: '400px',
        height: '100px'
      });

      dialogRef.afterClosed().subscribe((result: boolean | undefined) => {
        if (result) {
          this.projectManager.setTitleBlockOptions(this.info);
          this.dialogRef.close(this.info);
        }
      });
    } else {
      this.projectManager.setTitleBlockOptions(this.info);
      this.dialogRef.close(this.info);
    }

  }

  async close() {
    this.dialogRef.close({ remainData: this.info });
  }

  async save() {
    const projectId = this.projectManager.getCurrentProjectId();
    const project = this.projectManager.getCurrentProject();
    const value = {
      titleBlockOptions: { ...this.info },
      items: project.draw_options && project.draw_options.items ? project.draw_options.items : {}
    };
    if (projectId) {
      if (this.auth.getRole() == "admin") {
        this.projectManager.updateTemplateItem(projectId, 'draw_options', value).subscribe(r => {
          // console.log("Save TB options to Template - ", projectId);
          this.projectManager.setProject(r);
          this.dialogRef.close({ remainData: null });
        });
      }
      else if (this.auth.getRole() == "salesManager") {
        this.projectManager.updateProjectItem(projectId, 'draw_options', value).subscribe(r => {
          // console.log("Save TB options to Project - ", projectId);
          this.projectManager.setProject(r);
          this.dialogRef.close({ remainData: null });
        });
      }
    }
    else {
      // console.log("Previously need save project!");
      this.projectManager.setTitleBlockOptions({ ...this.info });
      this.dialogRef.close({ trigger: 'openSaveDialog' });
    }

  }

  clearAll() {
    if (this.cleared) {
      this.info = this.oldData;
      this.oldData = null;
      this.info.Cleared = false;
    } else {
      this.oldData = this.info;
      this.info = new TitleBlockInfo(this.date);
      this.info.Cleared = true;
    }

  }

}


// WEBPACK FOOTER //
// ./src/app/services/proTools/ng-components/title-block-info/title-block-info.component.ts